<template>
<div class="region-select">
    <div class="select-header" @click="open = !open">
        <div v-if="!selected_region">Оберіть область</div> 
        <div v-else>{{ selected_region.region }} </div>
        
        <div class="chevron"> </div>
    </div>

    <template v-if="open">
        <div class="region small-text" v-for="r in regions" :key="r.region" @click="onclick(r)">
            {{r.region}}
        </div>
    </template>
</div>
</template>

<script>
export default {
    props: ['regions', 'config'],
    
    data() {
        return {
            selected_region: null,
            open: true,
        } 
    },

    methods: {
        onclick(r){
            this.selected_region = r;
            this.open = false;
        }
    },

    watch: {
        selected_region(val) {
            this.$emit('change', val)
        }
    }
}
</script>     

<style lang="scss" scoped>
    .region-select {
        max-width: 21em;
    }

    .select-header {
        background-color: var(--col-mainblue);
        color: white;
        padding: 0.4em;

        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
    }

    .region {
        color: var(--col-mainblue);
        cursor: pointer;

        &:hover {
            background-color: var(--col-mainblue);
            color: white;
        }
    } 

    $chevron_size: 0.5em;

    .chevron {
        display: inline-block;
        margin: 0 0.5em;

        width: 0; 
        height: 0; 
        border-top: $chevron_size solid transparent;
        border-bottom: $chevron_size solid transparent;
        border-left: $chevron_size solid white;

        transition: transform 0.2s;
        transform: rotate(90deg);
   }

    
</style>
